<script lang="ts">
  import coinVideo from '$lib/assets/branding/Coin video.mp4'
  import { deferVideo } from '$lib/attachments/deferVideo'

  let heading = '[ TOKENOMICS ]'
</script>

<div class="mx-auto max-w-[1700px]">
  <section class="flex flex-col items-center sm-desktop:space-y-16">
    <div style="pointer-events: none;">
      <video
        {@attach deferVideo()}
        autoplay
        data-src={coinVideo}
        class="mx-auto max-h-[500px] scale-75 sm-desktop:h-[358px] sm-desktop:scale-125"
        playsinline
        loop
        muted
        defaultMuted
        disableremoteplayback
        oncontextmenu={(event) => event.preventDefault()}
        preload="none"
      >
      </video>
    </div>
    <div
      class="mx-auto w-[85%] text-center text-[7vw] font-medium leading-[135%] lg-tablet:text-[58px] sm-desktop:text-[92px] sm-desktop:leading-[100%]"
    >
      <h3
        class="mb-2 font-graphik text-[3.7vw] font-light uppercase tracking-wider lg-tablet:text-[24px] sm-desktop:text-[20px]"
      >
        {heading}
      </h3>
      <p>Public <span>43%</span></p>
      <p>Protocol <span>26.5%</span></p>
      <p>Team & Partners <span>17%</span></p>
      <p>Treasury Hedge <span>9%</span></p>
      <p>Private Sale <span>3%</span></p>
      <p>Other <span>1.5%</span></p>
    </div>
  </section>
</div>

<style>
  p {
    font-family: 'PPCirka';
    text-transform: uppercase;
  }

  span {
    background: linear-gradient(to right, #24caff, #fcb1a9, #ffa563);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
</style>
